module.exports = __webpack_public_path__ + "static/media/ms-button.8a94a35a.svg";